export default __webpack_public_path__ + "static/media/mail-icon-big.06b8582e.svg";